import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './cfgMsg.json';

const getCfgMsg = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['cfgMsgController/getCfgMsg'].success[req.body.path])));
};

export const handlers = [
  rest.post(getApiEndpoint('cfgMsgController/getCfgMsg'), withScenario(withAuthCheck(getCfgMsg))),
];
